import { useState, useCallback, useEffect, useRef } from 'react';
import Button from 'src/componentes/button';
import Dialog from 'src/componentes/dialog';
import jsxArray from 'src/utils/jsx-array';
import { ButtonToolbar } from 'reactstrap';
import { KEYS } from 'src/utils/keydown-decorator';
import Checkbox from 'src/componentes/checkbox';

export default function ConfirmacaoAprovacao({
  modelPerdaOperacional = {},
  handleCancel,
  handleConfirm,
  intl,
  resources,
  ...other
}) {
  const [notificarResponsavelArea, setNotificarResponsavelArea] = useState(false);
  const [notificarResponsavelAreaSuperior, setNotificarResponsavelAreaSuperior] = useState(false);

  const dialogRef = useRef(null);

  const handleCancelClick = useCallback(() => {
    setNotificarResponsavelArea(false);
    setNotificarResponsavelAreaSuperior(false);
    handleCancel && handleCancel();
    dialogRef.current?.close();
  }, [handleCancel]);

  const handleConfirmClick = useCallback(() => {
    handleConfirm?.(
      notificarResponsavelArea,
      notificarResponsavelAreaSuperior
    );
    dialogRef.current?.close();
  }, [
    handleConfirm,
    notificarResponsavelArea,
    notificarResponsavelAreaSuperior,
  ]);

  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.keyCode === KEYS.ESC) {
        handleCancelClick();
      }

      if (e.keyCode === KEYS.ENTER) {
        handleConfirmClick();
      }
    };

    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [handleCancelClick, handleConfirmClick]);

  const actions = jsxArray(
    <ButtonToolbar>
      <Button onClick={handleCancelClick} color="secondary">
        {intl.formatMessage({ id: 'label.cancelar' })}
      </Button>
      <Button
        className="ml-2"
        autoFocus
        type="primary"
        onClick={handleConfirmClick}
      >
        {intl.formatMessage({ id: 'aprovar' })}
      </Button>
    </ButtonToolbar>
  );

  return (
    <Dialog
      {...other}
      width={500}
      ref={dialogRef}
      title={intl.formatMessage({ id: 'titleModalAprovacaoPerdaOperacional' }, {perdaoperacional: resources.perdaoperacional, nomedaperdaoperacional: modelPerdaOperacional?.nome})}
      actions={actions}
      onRequestClose={handleCancelClick}
      padContent
    >
      <div className="mb-3">{intl.formatMessage({ id: 'msgAprovacaoPerdaOperacional' }, {perdaoperacional: resources.perdaoperacional})}</div>
      {modelPerdaOperacional?.exibirOpcoesNotificarAreaGeradora && (
        <>      
          <div className="mb-3">{intl.formatMessage({ id: 'escolhaQuemSeraNotificadoAoAprovarPerda' }, {perdaoperacional: resources.perdaoperacional})}</div>
          <Checkbox
            className="mb-3"
            model={{
              value: notificarResponsavelArea,
              label: intl.formatMessage(
                { id: 'notificarResponsavelArea' },
                { responsavel: resources.responsavel, area: resources.area }
              ),
              requestChange: setNotificarResponsavelArea,
            }}
          />
          <Checkbox
            className="mb-3"
            model={{
              value: notificarResponsavelAreaSuperior,
              label: intl.formatMessage(
                { id: 'notificarResponsavelAreaSuperior' },
                { responsavel: resources.responsavel, area: resources.area }
              ),
              requestChange: setNotificarResponsavelAreaSuperior,
            }}
          />
        </>
      )}
    </Dialog>
  );
};
